module.exports = __webpack_public_path__ + "img/logo.f003c055.png";